import React, { Component } from "react";

class Linkedin extends Component {
  render() {
    return (
      <a
        className="footer-icon"
        href="https://www.linkedin.com/in/dane-brown-81665b13b/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="50"
          height="52"
          viewBox="0 0 50 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50 25.6257C50 39.7784 38.8071 51.2515 25 51.2515C11.1929 51.2515 0 39.7784 0 25.6257C0 11.473 11.1929 0 25 0C38.8071 0 50 11.473 50 25.6257ZM39.9373 38.2529V27.6883C39.9373 22.031 36.9897 19.3981 33.0582 19.3981C29.883 19.3981 28.4667 21.1887 27.6726 22.4412V19.8307H21.696C21.7762 21.5587 21.696 38.2525 21.696 38.2525H27.6721V27.9638C27.6721 27.4115 27.7127 26.8647 27.87 26.471C28.3031 25.3692 29.284 24.2313 30.9351 24.2313C33.0988 24.2313 33.9616 25.9215 33.9616 28.3964V38.2529H39.9373ZM27.6726 22.4412V22.5015H27.6329C27.6386 22.4911 27.646 22.4805 27.6535 22.4698C27.6602 22.4604 27.6669 22.4508 27.6726 22.4412ZM12.0628 14.1331C12.0628 12.3261 13.4002 10.9507 15.4444 10.9507C17.489 10.9507 18.7453 12.3261 18.785 14.1331C18.785 15.9018 17.489 17.3169 15.4047 17.3169H15.366C13.3614 17.3169 12.0628 15.9018 12.0628 14.1331ZM18.3919 38.2529H12.418V19.8307H18.3919V38.2529Z"
            fill="#0077B5"
          />
        </svg>
      </a>
    );
  }
}

export default Linkedin;
